<template>
  <div class="lottie-bg" v-loading="true" element-loading-text="拼命加载中">
    <div id="lottie">
      <!-- <img
        src="@assets/images/live-logo.gif"
        rel="preload"
        style="width: 100%"
      /> -->
    </div>
  </div>
</template>

<script>
import { auth } from "@libs/wechat";
import { wechatAuth } from "@api/public";
import cookie from "@utils/store/cookie";

export default {
  name: "Loading",
  mounted() {
    let url = window.location.href
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1]
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&')
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=')
      obj[arr[0]] = arr[1];
    }
    const { code, state, type } = obj;
    let uid = localStorage.getItem("uid");
    if (!uid) {
      uid = null;
    }
    let that = this;
    auth(code, state, uid)
      .then((res) => {
        let loginPath = localStorage.getItem('loginPath');
        if (loginPath == '/login') {
          this.$router.push("/user");
          localStorage.setItem('loginPath', '');
        } else {
          this.$router.push({ path: loginPath.length ? loginPath : "/user" });
          localStorage.setItem('loginPath', '');
        }
      })
      .catch((err) => {
        that.$router.push({ path: "/login" });

      });
  },
};
</script>

<style scoped>
.lottie-bg {
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

#lottie {
  width: 35%;
  display: block;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  margin: auto;
}
</style>
